import { render, staticRenderFns } from "./FixedProductNav.vue?vue&type=template&id=ad2c0654&scoped=true&"
import script from "./FixedProductNav.vue?vue&type=script&lang=js&"
export * from "./FixedProductNav.vue?vue&type=script&lang=js&"
import style0 from "./FixedProductNav.vue?vue&type=style&index=0&id=ad2c0654&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2c0654",
  null
  
)

export default component.exports